module Shared {
    export class StatePensionAge {
        birthDate: Date;
        pensionDate: Date;
        age: number;    
    }
}